// Client-only helpers to remember the email a guest visitor used during a
// Maya Premium checkout, plus the page they came from. These let us:
//   1. Unlock Maya guides automatically when the visitor returns to the
//      destination page without signing in.
//   2. Bounce the buyer straight back to the destination they unlocked
//      from the `/maya/return` confirmation page.
//   3. Recover purchases later by email without contacting support.
const EMAIL_KEY = "maya_guest_email";
const RETURN_KEY = "maya_return_path";

function safeWindow(): Window | null {
  if (typeof window === "undefined") return null;
  return window;
}

export function rememberMayaEmail(email: string | null | undefined): void {
  const w = safeWindow();
  if (!w || !email) return;
  try {
    w.localStorage.setItem(EMAIL_KEY, email.trim().toLowerCase());
  } catch {
    /* ignore quota / privacy errors */
  }
}

export function getRememberedMayaEmail(): string | null {
  const w = safeWindow();
  if (!w) return null;
  try {
    return w.localStorage.getItem(EMAIL_KEY);
  } catch {
    return null;
  }
}

export function rememberMayaReturnPath(path: string | null | undefined): void {
  const w = safeWindow();
  if (!w || !path) return;
  try {
    w.localStorage.setItem(RETURN_KEY, path);
  } catch {
    /* ignore */
  }
}

export function consumeMayaReturnPath(): string | null {
  const w = safeWindow();
  if (!w) return null;
  try {
    const v = w.localStorage.getItem(RETURN_KEY);
    if (v) w.localStorage.removeItem(RETURN_KEY);
    return v;
  } catch {
    return null;
  }
}
